import script from "./FormGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormGroup.vue?vue&type=script&setup=true&lang=ts"

import "./FormGroup.vue?vue&type=style&index=0&id=6a82f518&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a82f518"]])

export default __exports__